const loadItems = (button) => {
	const totalPages = parseInt($("[data-total-pages]").val());
	let currentPage = parseInt($("[data-current-page]").val());

	const nextPage = currentPage + 1;

	let nextUrl = $("[data-next-url]").val();
	nextUrl = nextUrl.replace(/page=[0-9]+/, "page=" + nextPage);

	button.setAttribute("disabled", "");
	button.classList.add("loading");

	$.ajax({
		url: nextUrl,
		type: "GET",
		dataType: "html",
		success: function (responseHTML) {
			// Aggiungi nuovi prodotti
			const newGridItems = $(responseHTML).find(".load-more-grid").html();
			$(".load-more-grid").append(newGridItems);

			// Aggiorna next-url e current-page con i nuovi valori dalla risposta
			const newNextUrl = $(responseHTML).find("[data-next-url]").val();
			const newCurrentPage = $(responseHTML).find("[data-current-page]").val();

			if (newNextUrl) {
				$("[data-next-url]").val(newNextUrl);
			}
			if (newCurrentPage) {
				$("[data-current-page]").val(newCurrentPage);
			}

			// Swatches se servono
			try {
				colorSwatches();
			} catch (err) {}
		},
		complete: function () {
			const updatedPage = parseInt($("[data-current-page]").val());

			button.removeAttribute("disabled");
			button.classList.remove("loading");

			if (updatedPage >= totalPages) {
				button.remove();
			} else {
				checkVisibility(); // continua l'infinite scroll
			}
		},
	});
};

const checkVisibility = () => {
	const spinnerList = document.querySelectorAll(".js-infinite-scroll");
	spinnerList.forEach((spinner) => {
		const sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					loadItems(spinner);
				}
			});
		});
		sectionObserver.observe(spinner);
	});
};

function loadMore() {
	document.querySelectorAll(".js-load-more").forEach((button) => {
		button.onclick = () => {
			loadItems(button);
		};
	});

	checkVisibility();
}

(function () {
	loadMore();
})();
